import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useLocation, useParams } from "react-router-dom";
import { MainLayout } from "pages/layouts";
import { getForm } from "types/gql-types";
import { LoadingSpinner } from "components/graphql-views";
import { LoneGrid } from "components/login/components/shared-components";
import { humanizeFormType } from "utils/form-types";
import FormClosedLayout from "pages/eligibility/components/form/form-closed";
import Authenticated from "./authenticated";

const GET_FORM = gql`
  query getForm($formId: ID!) {
    form(id: $formId) {
      type
      open
      property {
      interestListId
        name
        organization {
          name
        }
      }
    }
  }
`;

const FormLayout: React.FC = () => {
  const { formId } = useParams<{ formId: string }>();
  const location = useLocation();
  const isSignup = location.pathname.includes("/signup");

  const { loading, data: response } =
    useQuery<getForm>(GET_FORM, { fetchPolicy: "no-cache", variables: { formId } });
  if (loading) return <LoadingSpinner />;
  if (!response || !response.form.property || !response.form.property.organization) return null;
  if (!response.form.open) {
    return <FormClosedLayout
      propertyName={response.form.property.name}
      formType={response.form.type}
    />;
  }

  return (<MainLayout backgroundColor="white" showHeader showFooter>
    <LoneGrid>
      <Authenticated formId={formId || ""} interestListId={response.form.property.interestListId || ""} isSignup={isSignup}
        formType={humanizeFormType(response.form.type)}
        propertyName={response.form.property.name} />
    </LoneGrid>
  </MainLayout>);
};

export default FormLayout;
